export default {
  title: 'เว็บไซต์อาคาร',
  subtitle: 'ตั้งค่าเว็บไซต์สาธารณะสำหรับอาคารนี้',
  breadcrumb: 'เว็บไซต์',
  tabs: {
    editor: 'ตั้งค่าเว็บไซต์',
    pages: 'หน้าเว็บ',
  },
  slug: {
    label: 'ชื่อ URL',
    placeholder: 'เช่น peerapat-residence',
    hint: 'ใช้ได้เฉพาะตัวพิมพ์เล็ก ตัวเลข และขีดกลาง',
    preview_label: 'URL สาธารณะ',
    error_format: 'ใช้ได้เฉพาะตัวอักษร a-z, ตัวเลข 0-9 และขีดกลาง (-)',
    error_required: 'กรุณากรอก Slug',
  },
  template: {
    label: 'เทมเพลต',
    description: 'เลือกรูปแบบดีไซน์สำหรับเว็บไซต์อาคาร',
    modern_name: 'Modern',
    modern_description: 'ดีไซน์สะอาด เรียบง่าย เหมาะสำหรับอาคารสมัยใหม่',
    classic_name: 'Classic',
    classic_description: 'รูปแบบคลาสสิกอบอุ่น เหมาะสำหรับที่พักแบบดั้งเดิม',
    elegant_name: 'Elegant',
    elegant_description: 'ดีไซน์หรูหรา พรีเมียม',
  },
  theme: {
    section_colors: 'สี',
    section_fonts: 'ฟอนต์',
    section_images: 'รูปภาพ',
    section_footer: 'ท้ายหน้า',
    primary_color: 'สีหลัก',
    secondary_color: 'สีรอง',
    accent_color: 'สีเน้น',
    button_color: 'สีปุ่ม',
    button_text_color: 'สีตัวอักษรปุ่ม',
    header_bg_color: 'พื้นหลังส่วนหัว',
    header_text_color: 'ตัวอักษรส่วนหัว',
    footer_bg_color: 'พื้นหลังท้ายหน้า',
    footer_text_color: 'ตัวอักษรท้ายหน้า',
    font_family: 'ฟอนต์เนื้อหา',
    heading_font_family: 'ฟอนต์หัวเรื่อง',
    logo_url: 'โลโก้',
    logo_hint: 'แนะนำ: PNG พื้นหลังโปร่งใส ความกว้างขั้นต่ำ 200px',
    hero_image_url: 'รูปหลัก (Hero)',
    hero_image_hint: 'แนะนำ: 1920×1080px หรือกว้างกว่า',
    favicon_url: 'Favicon',
    favicon_hint: 'แนะนำ: 32×32px หรือ 64×64px PNG หรือ ICO',
    footer_text: 'ข้อความท้ายหน้า',
    footer_text_placeholder: '© 2025 Peerapat Residence สงวนลิขสิทธิ์',
    contact_phone: 'เบอร์โทรติดต่อ',
    contact_phone_placeholder: '02-xxx-xxxx',
    contact_email: 'อีเมลติดต่อ',
    contact_email_placeholder: 'contact@peerapat.com',
    contact_address: 'ที่อยู่',
    contact_address_placeholder: '123 ถนนสุขุมวิท กรุงเทพฯ 10110',
    section_seo: 'SEO และการแชร์',
    seo: {
      title: 'SEO และการแชร์',
      meta_description: 'Meta Description',
      meta_description_placeholder: 'คำอธิบายสำหรับผลการค้นหา (150-160 ตัวอักษร)',
      og_title: 'ชื่อสำหรับแชร์',
      og_title_placeholder: 'ชื่อโครงการ (ค่าเริ่มต้น)',
      og_description: 'คำอธิบายสำหรับแชร์',
      og_description_placeholder: 'คำอธิบายสั้นๆ ที่แสดงเมื่อแชร์ลิงก์',
      og_image: 'รูปภาพสำหรับแชร์',
      og_image_hint: 'รูปภาพที่แสดงเมื่อแชร์บน LINE, Facebook ฯลฯ',
    },
    analytics: {
      title: 'Analytics & Tracking',
      gtm_id: 'Google Tag Manager ID',
      gtm_id_placeholder: 'GTM-XXXXXXX',
      ga4_id: 'Google Analytics 4 ID',
      ga4_id_placeholder: 'G-XXXXXXXXXX',
      clarity_id: 'Microsoft Clarity ID',
      clarity_id_placeholder: 'xxxxxxxxxx',
      hint: 'สคริปต์วิเคราะห์จะทำงานหลังได้รับความยินยอมคุกกี้',
    },
  },
  pages: {
    section_title: 'หน้าเว็บ',
    add_page: 'เพิ่มหน้าเว็บ',
    edit_page: 'แก้ไขหน้าเว็บ',
    delete_page: 'ลบหน้าเว็บ',
    move_up: 'ย้าย "{{title}}" ขึ้น',
    move_down: 'ย้าย "{{title}}" ลง',
    unpublish_page: 'ยกเลิกเผยแพร่ "{{title}}"',
    publish_page: 'เผยแพร่ "{{title}}"',
    create_defaults: 'สร้างหน้าเริ่มต้น',
    create_defaults_hint: 'สร้างหน้า หน้าหลัก, เกี่ยวกับ, ติดต่อ และห้องพัก โดยอัตโนมัติ',
    empty_title: 'ยังไม่มีหน้าเว็บ',
    empty_description: 'เพิ่มหน้าเว็บเพื่อสร้างเว็บไซต์อาคาร',
    page_type_label: 'ประเภทหน้า',
    page_types: {
      home: 'หน้าหลัก',
      about: 'เกี่ยวกับ',
      contact: 'ติดต่อ',
      rooms: 'ห้องพัก',
      room: 'ห้อง',
      custom: 'กำหนดเอง',
    },
    content_fields: 'เนื้อหาหน้า',
    fields: {
      title: 'ชื่อหน้า',
      title_placeholder: 'เช่น เกี่ยวกับเรา',
      slug: 'Slug',
      published: 'เผยแพร่',
      show_in_nav: 'แสดงในเมนู',
    },
    home: {
      section_hero: 'ส่วนเปิด (Hero)',
      hero_title: 'หัวข้อหลัก',
      hero_title_placeholder: 'ยินดีต้อนรับสู่ที่พักของเรา',
      hero_subtitle: 'คำบรรยายใต้หัวข้อ',
      hero_subtitle_placeholder: 'ที่พักทันสมัยใจกลางเมือง',
      hero_cta: 'ข้อความปุ่ม',
      hero_cta_placeholder: 'ดูห้องพัก',
      description: 'รายละเอียด',
      description_placeholder: 'แนะนำอาคารของคุณให้ผู้เยี่ยมชม...',
      rooms_title: 'ห้องพักแนะนำ',
      room_name: 'ชื่อห้อง',
      room_name_placeholder: 'เช่น สตูดิโอ',
      room_price: 'ราคา (บาท/เดือน)',
      room_size: 'ขนาด (ตร.ม.)',
      room_image: 'รูปภาพ',
      add_room: 'เพิ่มห้อง',
    },
    room: {
      room_name: 'ชื่อห้อง',
      room_name_placeholder: 'เช่น 1 ห้องนอน',
      price: 'ราคา (บาท/เดือน)',
      size_sqm: 'ขนาด (ตร.ม.)',
      description: 'รายละเอียด',
      description_placeholder: 'อธิบายประเภทห้องนี้...',
      amenities: 'สิ่งอำนวยความสะดวก',
      amenity_placeholder: 'เช่น Wi-Fi, แอร์, ที่จอดรถ',
      add_amenity: 'เพิ่มสิ่งอำนวยความสะดวก',
      images: 'รูปภาพห้อง',
      images_hint: 'อัปโหลดรูปภาพของห้องประเภทนี้',
      available_rooms: 'ห้องว่าง',
      add_available_room: 'เพิ่มห้อง',
    },
    contact: {
      heading: 'หัวข้อ',
      heading_placeholder: 'ติดต่อเรา',
      description: 'รายละเอียด',
      description_placeholder: 'แจ้งให้ผู้เยี่ยมชมทราบวิธีติดต่อ...',
      contact_info: 'ข้อมูลติดต่อ',
      phone: 'เบอร์โทร',
      phone_placeholder: '02-xxx-xxxx',
      email: 'อีเมล',
      email_placeholder: 'contact@example.com',
      address: 'ที่อยู่',
      address_placeholder: '123 ถนนสุขุมวิท กรุงเทพฯ 10110',
      google_maps_url: 'URL แผนที่ Google Maps',
      google_maps_url_placeholder: 'https://www.google.com/maps/embed?pb=...',
    },
    button: {
      section: 'ปุ่ม',
      text: 'ข้อความปุ่ม',
      text_placeholder: 'เช่น ดูห้องพัก',
      action_type: 'ประเภทการกระทำ',
      types: {
        link: 'ลิงก์ (URL)',
        page: 'หน้าเว็บ',
        phone: 'โทรศัพท์',
        email: 'อีเมล',
        line: 'LINE',
      },
      url: 'URL',
      page_slug: 'Slug หน้าเว็บ',
      page_slug_placeholder: 'เช่น room/1',
      phone: 'เบอร์โทรศัพท์',
      email: 'ที่อยู่อีเมล',
      line_id: 'LINE ID',
    },
    messages: {
      delete_confirm: 'คุณแน่ใจว่าต้องการลบ "{{title}}" ใช่ไหม? การดำเนินการนี้ไม่สามารถยกเลิกได้',
      create_success: 'สร้างหน้าเว็บแล้ว',
      update_success: 'อัปเดตหน้าเว็บแล้ว',
      delete_success: 'ลบหน้าเว็บแล้ว',
      create_error: 'สร้างหน้าเว็บไม่สำเร็จ',
      update_error: 'อัปเดตหน้าเว็บไม่สำเร็จ',
      delete_error: 'ลบหน้าเว็บไม่สำเร็จ',
      creating_defaults: 'กำลังสร้างหน้าเริ่มต้น...',
    },
  },
  actions: {
    save: 'บันทึกการตั้งค่า',
    publish: 'เผยแพร่',
    publishing: 'กำลังเผยแพร่...',
    view_site: 'ดูเว็บไซต์',
  },
  status: {
    published: 'เผยแพร่แล้ว',
    unpublished: 'ยังไม่เผยแพร่',
    last_published: 'เผยแพร่ล่าสุด {{date}}',
  },
  messages: {
    save_success: 'บันทึกการตั้งค่าเว็บไซต์แล้ว',
    save_error: 'บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง',
    publish_success: 'กำลังเผยแพร่เว็บไซต์ อาจใช้เวลาสักครู่',
    publish_error: 'เผยแพร่ไม่สำเร็จ กรุณาลองอีกครั้ง',
  },
  empty: {
    title: 'ยังไม่มีการตั้งค่าเว็บไซต์',
    description: 'กรอก Slug และเลือกเทมเพลตเพื่อเริ่มต้น',
  },
  preview: {
    title: 'ตัวอย่างธีม',
    desktop: 'เดสก์ท็อป',
    mobile: 'มือถือ',
    mobile_too_narrow: 'หน้าจอแคบเกินไปสำหรับตัวอย่างมือถือ กรุณาซูมออกหรือขยายเบราว์เซอร์',
    nav_home: 'หน้าหลัก',
    nav_rooms: 'ห้อง',
    nav_contact: 'ติดต่อ',
    hero_title: 'ยินดีต้อนรับสู่ที่พักของเรา',
    hero_subtitle: 'ที่พักทันสมัยใจกลางเมือง',
    hero_cta: 'ดูห้องพัก',
    featured_rooms: 'ห้องพักแนะนำ',
    details: 'รายละเอียด',
    available_rooms: 'ห้องว่าง',
    available: 'ว่าง',
    inquire: 'สอบถาม',
    per_month: '/เดือน',
    sqm: 'ตร.ม.',
    footer_contact: 'ติดต่อ',
    footer_phone: 'โทรศัพท์',
    footer_email: 'อีเมล',
    footer_pages: 'หน้า',
    contact_us: 'ติดต่อเรา',
    send_message: 'ส่งข้อความ',
    form_name: 'ชื่อ',
    form_email: 'อีเมล',
    form_message: 'ข้อความ',
    send: 'ส่ง',
    book_now: 'จองเลย',
    new_badge: 'ใหม่',
    template_label: 'เทมเพลต',
    default_address: '123 ถนนสุขุมวิท กรุงเทพฯ',
    room_description: 'ห้องกว้างขวางพร้อมเฟอร์นิเจอร์ทันสมัย เครื่องปรับอากาศ และระเบียงส่วนตัวมองเห็นวิวเมือง รวม Wi-Fi ที่จอดรถ และรปภ. 24 ชั่วโมง',
    studio: 'สตูดิโอ',
    one_br: '1 ห้องนอน',
    two_br: '2 ห้องนอน',
    penthouse: 'เพนท์เฮาส์',
  },
  card: {
    status_published: 'เผยแพร่แล้ว',
    status_publishing: 'กำลังเผยแพร่...',
    status_failed: 'เผยแพร่ล้มเหลว',
    status_draft: 'ฉบับร่าง',
    last_published: 'เผยแพร่ล่าสุด {{date}}',
    never_published: 'ยังไม่เคยเผยแพร่',
    edit_button: 'แก้ไขเว็บไซต์',
    setup_button: 'ตั้งค่าเว็บไซต์',
  },
}
